import { useGetEcSiteOrdersSystemTypes } from '@/hooks/features/ecSiteOrders'

export const useCheckSystemTypesForPurchaseMaster = () => {
  const { isLoading, isSuccess } = useGetEcSiteOrdersSystemTypes({
    queryParams: {
      yahooType: 'merged',
    },
    config: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  })

  return {
    isStored: isSuccess,
    isLoading,
  }
}
